import { api } from '@/lib/api';
import type { GroomerDetailsRequest, GroomerDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/groomer';

export async function save_groomer_details(
  input: GroomerDetailsRequest,
): Promise<GroomerDetailsResponse> {
  const res = await api.post<GroomerDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_groomer_details(): Promise<GroomerDetailsResponse | null> {
  const res = await api.get<GroomerDetailsResponse | null>(URL);
  return res.data;
}
